export default "__VITE_ASSET__Cq4Mn9f1__"